import { IxValidationMessageType } from 'ix-ng-forms';

export const getMessageType = (type: IxValidationMessageType | string): string => {
  if (typeof type === 'string') {
    switch (type) {
      case 'INFORMATION':
        return 'fa-info-circle';
      case 'WARNING':
        return 'fa-exclamation-triangle';
      case 'WARNINGERROR':
        return 'fa-exclamation-triangle';
      case 'ERROR':
        return 'fa-exclamation-circle';
      default:
        return 'fa-exclamation-circle';
    }
  } else {
    switch (type) {
      case IxValidationMessageType.INFORMATION:
        return 'fa-info-circle';
      case IxValidationMessageType.WARNING:
        return 'fa-exclamation-triangle';
      case IxValidationMessageType.WARNINGERROR:
        return 'fa-exclamation-triangle';
      case IxValidationMessageType.ERROR:
        return 'fa-exclamation-circle';
      default:
        return 'fa-exclamation-circle';
    }
  }
};

export const getMessageColor = (type: IxValidationMessageType | string): string => {
  if (typeof type === 'string') {
    switch (type) {
      case 'INFORMATION':
        return '#4CAF50';
      case 'WARNING':
      case 'WARNINGERROR':
        return '#E8EE4A';
      case 'ERROR':
        return '#E91E63';
      default:
        return '#E91E63';
    }
  } else {
    switch (type) {
      case IxValidationMessageType.INFORMATION:
        return '#4CAF50';
      case IxValidationMessageType.WARNING:
      case IxValidationMessageType.WARNINGERROR:
        return '#E8EE4A';
      case IxValidationMessageType.ERROR:
        return '#E91E63';
      default:
        return '#E91E63';
    }
  }
};

export const getMessageTypeText = (type: IxValidationMessageType | string): string => {
  if (typeof type === 'string') {
    switch (type) {
      case 'INFORMATION':
        return 'Obvestilo';
      case 'WARNING':
        return 'Opozorilo';
      case 'WARNINGERROR':
        return 'Opozorilo (o)';
      case 'ERROR':
        return 'Blokada';
      default:
        return 'Blokada';
    }
  } else {
    switch (type) {
      case IxValidationMessageType.INFORMATION:
        return 'Obvestilo';
      case IxValidationMessageType.WARNING:
        return 'Opozorilo';
      case IxValidationMessageType.ERROR:
        return 'Blokada';
      default:
        return 'Blokada';
    }
  }
};
